import { computed } from 'mobx';
import { observer } from 'mobx-react';
import stores from 'stores';

const _createDataLoadedComputed = function(expr) {
  return computed(expr.bind(null, stores));
};

const _createDataViewingNavigation = function name(titleKey) {
  return {
    titleKey,
    captionKey: '',
    className: 'data-viewing-page',
    dataLoaded: _createDataLoadedComputed(function(stores) {
      return stores.orderStore.orderDataLoadInProgress;
    })
  };
};

const navigationMap = observer({
  home: {
    titleKey: 'landingPage',
    captionKey: 'landingPage',
    dataLoaded: _createDataLoadedComputed(function(stores) {
      return stores.tradingVenuesStore.isVenuesLoadInProgress;
    })
  },
  login: {
    titleKey: 'login',
    captionKey: 'login',
    dataLoaded: _createDataLoadedComputed(function(stores) {
      return stores.userStore.isLogginInInprogress;
    })
  },
  restorePassword: {
    titleKey: 'restorePassword',
    className: 'restore-password-page',
    dataLoaded: _createDataLoadedComputed(function(stores) {
      return stores.userStore.questionLoading;
    })
  },
  register: {
    titleKey: 'register',
    captionKey: 'register',
    dataLoaded: _createDataLoadedComputed(function(stores) {
      return stores.tradingVenuesStore.isVenuesLoadInProgress || stores.userStore.isRegisterInProgress;
    })
  },
  feedRegister: {
    titleKey: 'feedRegister',
    captionKey: 'feedRegister',
    className: 'feed-register-page'
  },
  sliceRegister: {
    titleKey: 'sliceRegister',
    captionKey: 'sliceRegister',
    dataLoaded: _createDataLoadedComputed(function(stores) {
      return stores.tradingVenuesStore.isVenuesLoadInProgress || stores.userStore.isRegisterInProgress;
    })
  },
  dataViewing: _createDataViewingNavigation('dataViewing'),
  tradeDataViewing: _createDataViewingNavigation('tradeDataViewing'),
  orderDataViewing: _createDataViewingNavigation('orderDataViewing'),

  preferences: {
    titleKey: 'preferences',
    captionKey: 'preferences',
    className: 'preferences-page'
  },

  dataSelect: {
    titleKey: 'dataSelect',
    captionKey: 'dataSelect',
    className: 'data-select-page',
    dataLoaded: _createDataLoadedComputed(function(stores) {
      return stores.orderStore.orderDataLoadInProgress;
    })
  },

  termsOfUse: {
    titleKey: 'termsOfUse',
    captionKey: 'termsOfUse',
    className: 'terms-of-use-page'
  },

  underConstruction: {
    titleKey: 'underConstruction',
    captionKey: 'underConstruction',
    className: 'under-construction'
  },

  myAccount: {
    titleKey: 'myAccount',
    captionKey: 'myAccount',
    className: 'my-account'
  },

  details: {
    titleKey: 'myAccount',
    captionKey: 'myAccount',
    className: 'my-account',
    dataLoaded: _createDataLoadedComputed(function(stores) {
      return stores.userStore.isUserDetailsUpdateInProgress;
    })
  },

  subscriptions: {
    titleKey: 'subscriptions',
    captionKey: 'subscriptions',
    className: 'subscriptions',
    dataLoaded: _createDataLoadedComputed(function(stores) {
      return stores.tradingVenuesStore.subscriptionUpdateInProgress;
    })
  },

  changePassword: {
    titleKey: 'changePassword',
    captionKey: 'changePassword',
    className: 'change-password'
  },

  executionReporting: {
    titleKey: 'executionReporting',
    captionKey: 'executionReporting',
    dataLoaded: _createDataLoadedComputed(function(stores) {
      return stores.executionReportingStore.isLoadingPublisers;
    })
  },

  executionReportingDownload: {
    titleKey: 'executionReportingDownload',
    captionKey: 'executionReportingDownload',
    dataLoaded: _createDataLoadedComputed(function(stores) {
      return stores.executionReportingStore.isLoadingReports;
    })
  },

  documentation: {
    titleKey: 'documentation',
    captionKey: 'documentation',
    dataLoaded: _createDataLoadedComputed(function(stores) {
      return stores.documentationStore.isLoadingLinks;
    })
  },

  transparency: {
    titleKey: 'transparency',
    captionKey: 'transparency'
  },
});

export default navigationMap;



// WEBPACK FOOTER //
// ./src/containers/layouts/MainLayout/navigationMap.js